import { render, staticRenderFns } from "./PlatformDetails.vue?vue&type=template&id=5b2a3528&scoped=true"
import script from "./PlatformDetails.vue?vue&type=script&lang=js"
export * from "./PlatformDetails.vue?vue&type=script&lang=js"
import style0 from "./PlatformDetails.vue?vue&type=style&index=0&id=5b2a3528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a3528",
  null
  
)

export default component.exports